const tooltip = (function () {
    //enable bootstrap tooltip
    $('[data-toggle="tooltip"]').each((i, t) => {
        let html = $(t).attr("title")
        $(t).attr("title", decodeURI(html))
    });
    //custom trigger for tooltip
    $('[data-toggle="tooltip"]').tooltip({
        trigger: "manual",
        html: true
    }).on("mouseenter", function () {
        let _this = this;
        $(this).tooltip("show");
        $(".tooltip").on("mouseleave", function () {
            $(_this).tooltip('hide');
        });
    }).on("mouseleave", function () {
        var _this = this;
        if (!$(".tooltip:hover").length) {
            $(_this).tooltip("hide");
        }
    });
})();

export default tooltip;